import { all, put, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../requests';

export function* listToDo(action) {
  try {
    const { payload } = action;
    const response = yield API.listTodo();
    yield put({
      type: ActionTypes.TODO_GET_ALL_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.TODO_GET_ALL_FAILURE,
    });
  }
}

export function* listToDoByStudent(action) {
  try {
    const { payload } = action;
    const response = yield API.listToDoByStudent(payload);
    yield put({
      type: ActionTypes.TODO_GET_ALL_BY_STUDENT_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.TODO_GET_ALL_BY_STUDENT_FAILURE,
    });
  }
}

export function* addTodo(action) {
  try {
    const { payload } = action;
    const response = yield API.addTodo(payload);
    yield put({
      type: ActionTypes.TODO_ADD_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.TODO_ADD_FAILURE,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.TODO_GET_ALL_REQUEST, listToDo),
    takeLatest(ActionTypes.TODO_GET_ALL_BY_STUDENT_REQUEST, listToDoByStudent),
    takeLatest(ActionTypes.TODO_ADD_REQUEST, addTodo),
  ]);
}
